import { useContext } from 'react';

import { FlowManagerContext } from '../FlowManagerProvider';

export function useRootPath() {
  const context = useContext(FlowManagerContext);

  if (!context) {
    throw new Error('flow not initialized');
  }

  return { value: context.rootPath };
}
